<template lang="pug">
    //- .category-item {{ $route.params.id }}
    section(:class="{ empty: !products || !products.length }")
        .loader(v-if="loading" v-loading="loading")
        el-alert(
            v-else-if="currentCategory.id === '__orphans'"
            type="warning"
            :title="$t('Something went wrong! Here are some categories that could not be positioned inside the tree.')"
            :closable="false"
            effect="dark"
        )
        el-collapse(v-else-if="currentCategory" v-model="currentCollapseItem" accordion)
            el-collapse-item.settings(:title="$t('Settings')" name="settings")
                template(v-if="currentCategory")
                    el-row.no-margin(:gutter="40")
                        el-col(:lg="14" :md="12")
                            el-form-item.no-margin(:label="$t('Name')" :prop="`categories.${currentCategoryIndex}.name`")
                                el-input(v-model="name" maxlength="255" show-word-limit)
                        el-col(:lg="10" :md="12")
                            el-form-item.no-margin(:label="$t('Key')" :prop="`categories.${currentCategoryIndex}.key`")
                                el-input(v-model="key" maxlength="255" show-word-limit)
                    //- .restriction-row(v-if="enabledExtensions.includes('restricted-area')")
                    //-     el-form-item(:label="$t('Accessible by')" :prop="`categories.${currentCategoryIndex}.restriction`")
                    //-         el-select.is-full-width(placeholder="" v-model="restriction")
                    //-             el-option(
                    //-                 v-for="restriction in restrictions"
                    //-                 :key="restriction.key"
                    //-                 :label="restriction.name"
                    //-                 :value="restriction.value"
                    //-             )
                    //- .content-status-flex-row
                        .content-status-flex-col.datepickers
                            el-row(:gutter="20")
                                el-col(:span="12")
                                    el-form-item.no-margin.is-full-width(
                                        :label="$t('Publish start')"
                                        :prop="`categories.${currentCategoryIndex}.page.publish_start`"
                                    )
                                        el-date-picker.is-full-width(
                                            v-model="publishStart"
                                            type="date"
                                            :format="$t('yyyy-MM-dd')"
                                            prefix-icon="far el-icon-fa-calendar-alt"
                                            :picker-options="{firstDayOfWeek:1, disabledDate: disabledPublishStartDate}"
                                        )
                                el-col(:span="12")
                                    el-form-item.no-margin.is-full-width(
                                        :label="$t('Publish end')"
                                        ::prop="`categories.${currentCategoryIndex}.page.publish_end`"
                                    )
                                        el-date-picker.is-full-width(
                                            v-model="publishEnd"
                                            type="date"
                                            :format="$t('yyyy-MM-dd')"
                                            prefix-icon="far el-icon-fa-calendar-alt"
                                            :picker-options="{firstDayOfWeek:1, disabledDate: disabledPublishEndDate}"
                                        )
                        .content-status-flex-col.status-switch
                            el-form-item.no-margin
                                el-switch(
                                    :active-text="$t('Active')"
                                    inactive-color="#ff4949"
                                    v-model="status"
                                )

            template(v-if="isOrphan === false" v-for="productImport in productImports")
                el-collapse-item.settings(:title="productImport.name" :key="productImport.key" :name="productImport.key")
                    ProductImport(:config="productImport" :category="currentCategory")
            template(v-if="isOrphan === false" v-for="productExport in productExports")
                el-collapse-item.settings(:title="productExport.name" :key="productExport.key" :name="productExport.key")
                    ProductExport(:config="productExport" :category="currentCategory")
            el-collapse-item.products(v-if="! hideMain" :title="$t('Products')" name="products")
                .category-products
                    .category-products-empty(v-if="categoryProductsIsEmpty" v-loading="categoryProductsLoading")
                        .category-products-empty__icon
                            i.el-icon-fa-box-open.fas
                        p.category-products-empty__title
                            template(v-if="includeSubcategories") {{ $t('No products in this category or its subcategories') }}
                            template(v-else) {{ $t('No products in this category yet') }}
                        p.category-products-empty__hint {{ $t('Assign products to this category while editing a product.') }}
                        .category-products-empty__actions
                            el-switch(
                                v-if="!currentCategoryIsLeaf"
                                v-model="includeSubcategories"
                                :active-text="$t('Include subcategories')"
                            )
                            router-link(to="/catalog/products")
                                el-button(plain size="small" type="primary" icon="el-icon-fa-tag fas") {{ $t('Go to products') }}
                    paginated-items(
                        v-else
                        scope="ex"
                        type="shop_category_product"
                        :loading="categoryProductsLoading"
                        :items="categoryProductsPaginated.items"
                        :filters="categoryProductsFilters"
                        :show-filters="categoryProductsShowFilters"
                        :variables="categoryProductsPaginated.variables"
                        :all-columns="categoryProductsPaginated.allColumns"
                        :active-columns="categoryProductsPaginated.activeColumns"
                        :page-info="categoryProductsPaginated.pageInfo"
                        :sort="categoryProductsSort"
                        @pagination-size-change="categoryProductsChangePaginationSize"
                        @pagination-current-change="categoryProductsChangeCurrentPage"
                        @show-table-columns="categoryProductsHandleColsShow"
                        @change-filter="categoryProductsChangeFilter"
                        @change-sort="categoryProductsHandleSortChange"
                    )
                        template(slot="top")
                            el-row.table-top(type="flex" justify="space-between")
                                .left
                                    el-switch(
                                        v-if="!currentCategoryIsLeaf"
                                        v-model="includeSubcategories"
                                        :active-text="$t('Include subcategories')"
                                    )
                                .right
                                    el-button(
                                        plain
                                        size="mini"
                                        type="primary"
                                        icon="el-icon-fa-filter fas"
                                        @click="toggleCategoryProductsFilterVisibility"
                                        :disabled="categoryProductsHasActiveFilters"
                                    )
                                        span(v-if="categoryProductsShowFilters") {{ $t('Hide filters') }}
                                        span(v-else) {{ $t('Show filters') }}

                        template(v-slot:main_price_net="{ value }")
                            span {{ value | moneyFormat(defaultCustomerGroupCurrency) }}
                        template(v-slot:main_price_gross="{ value }")
                            span {{ value | moneyFormat(defaultCustomerGroupCurrency) }}
                        template(v-slot:sold_qty_sum="{ value }")
                            span(v-show="value > 0") {{ value }}
                        template(v-slot:status="{ value }")
                            span {{ $t(value) }}
                        template(v-slot:tags="{ item }")
                            .tags
                                el-tag(
                                    v-if="item.tags && item.tags.length"
                                    v-for="tag in item.tags.slice(0, 3)"
                                    :key="`${item.id}:${tag.id}`"
                                    type="info"
                                    effect="dark"
                                    size="small"
                                ) {{ tag.name }}
                                template(v-if="item.tags && item.tags.length > 3")
                                    el-popover(
                                        placement="top"
                                        :title="$t('Tags')"
                                        trigger="hover"
                                    )
                                        .tags.popover-body.mt-2
                                            el-tag(
                                                v-for="tag in item.tags"
                                                :key="`popover:${item.id}:${tag.id}`"
                                                type="info"
                                                effect="dark"
                                                size="mini"
                                            ) {{ tag.name }}
                                        el-button(
                                            type="text"
                                            slot="reference"
                                            @click.stop
                                        ) +{{ item.tags.length - 3 }}
                        template(v-slot:memberTags="{ item }")
                            .tags
                                el-tag(
                                    v-if="item.memberTags && item.memberTags.length"
                                    v-for="tag in item.memberTags.slice(0, 3)"
                                    :key="`${item.id}:${tag.id}`"
                                    type="info"
                                    effect="dark"
                                    size="small"
                                ) {{ tag.name }}
                                template(v-if="item.memberTags && item.memberTags.length > 3")
                                    el-popover(
                                        placement="top"
                                        :title="$t('Tags')"
                                        trigger="hover"
                                    )
                                        .tags.popover-body.mt-2
                                            el-tag(
                                                v-for="tag in item.memberTags"
                                                :key="`popover:${item.id}:${tag.id}`"
                                                type="info"
                                                effect="dark"
                                                size="mini"
                                            ) {{ tag.name }}
                                        el-button(
                                            type="text"
                                            slot="reference"
                                            @click.stop
                                        ) +{{ item.memberTags.length - 3 }}
                        template(v-slot:taxes="{ value }")
                            span {{ value || 0 }}%
</template>

<i18n>
{
    "de": {
        "Category could not be fetched.": "Menüpunkt konnte nicht abgerufen werden.",
        "Category could not be found.": "Menüpunkt konnte nicht gefunden werden.",
        "Something went wrong! Here are some categories that could not be positioned inside the tree.": "Etwas ist schief gelaufen! Hier sind einige Kategorien, die nicht innerhalb des Hierarchie-Baums positioniert werden konnten.",
        "Settings": "Einstellungen",
        "Products": "Produkte",
        "Include subcategories": "Unterkategorien einbeziehen",
        "No products in this category yet": "Diese Kategorie enthält noch keine Produkte",
        "No products in this category or its subcategories": "Weder diese Kategorie noch ihre Unterkategorien enthalten Produkte",
        "Assign products to this category while editing a product.": "Ordnen Sie Produkte beim Bearbeiten eines Produkts dieser Kategorie zu.",
        "Go to products": "Zu den Produkten",
        "Key": "Eindeutige Kennung",
        "No category selected!": "Kein Menüpunkt ausgewählt!"
    }
}
</i18n>

<script>
// import Vue from 'vue'

import _ from 'lodash';
// import draggable from 'vuedraggable'
import { compareAsc, compareDesc, addDays, startOfDay } from 'date-fns';

import NestedSet from '@/nested-set-lib';

import pinia from '@/pinia';
import { useSetupStore, useShopCategoriesStore, useShopCategoryProductStore } from '@/stores';

import PaginatedItems from '@/components/PaginatedItems';
import ProductImport from './Partials/ProductImport';
import ProductExport from './Partials/ProductExport';

import { adminClient as apolloClient } from '@/store/apollo';

export default {
    name: 'Category',
    data() {
        return {
            error: false,
            notFound: false,
            pathNotValid: false,
            loading: false,
            collapseItem: 'products',
            includeSubcategories: false,
        };
    },
    components: {
        PaginatedItems,
        ProductImport,
        ProductExport,
    },
    computed: {
        name: {
            get() {
                return _.get(this.currentCategory, 'name', '');
            },
            set(value) {
                if (this.currentCategoryIndex !== null) {
                    const i = this.currentCategoryIndex;
                    this.categoriesStore.setFormName({ i, value });
                }
            }
        },
        key: {
            get() {
                return _.get(this.currentCategory, 'key', '');
            },
            set(value) {
                if (this.currentCategoryIndex !== null) {
                    const i = this.currentCategoryIndex;
                    this.categoriesStore.setFormKey({ i, value });
                }
            }
        },
        // view: {
        //     get() {
        //         return _.get(this.currentCategory, 'page.view', '')
        //     },
        //     set(value) {
        //             if (this.currentCategoryIndex !== null) {
        //             const i = this.currentCategoryIndex

        //             switch (value) {
        //                 case 'Redirect':
        //                     store.commit('category/form/addHyperlinkToPage', i)
        //                     break;
        //             }

        //             store.commit('category/form/view', { i, value })

        //             const pageExtension = this.currentCategory.page.extension
        //             const configExtension = this.config.extension
        //             console.log(pageExtension, configExtension)
        //             if(configExtension && configExtension.key) {
        //                 const extension = this.activeCms.extensions.find(extension => extension.key === configExtension.key) || null
        //                 console.log(extension)
        //                 store.commit('category/form/changePageExtension', {categoryIndex: i, extension})
        //             }else if(pageExtension) {
        //                 store.commit('category/form/changePageExtension', {categoryIndex: i, extension: null})
        //             }
        //         }
        //     }
        // },
        // restriction: {
        //     get() {
        //         return _.get(this.currentCategory, 'restriction')
        //     },
        //     set(value) {
        //         if (this.currentCategoryIndex !== null) {
        //             const i = this.currentCategoryIndex
        //             store.commit('category/form/restriction', { i, value })
        //         }
        //     }
        // },
        currentCategory() {
            const categories = _.get(this.form, 'categories') || [];
            if (this.currentCategoryIndex !== null) return categories[this.currentCategoryIndex];
            else return null;
        },
        isOrphan() {
            const items = _.get(this.form, 'categories') || [];
            const ancestors = NestedSet.getAncestors(items, this.currentCategory).map(item => item.id);

            return this.currentCategory.id === '__orphans' || ancestors.includes('__orphans');
        },
        // config() {
        //     const view = _.get(this.currentCategory, 'page.view')
        //     const config = _.get(this.activeCms, 'config.template.pages', [])
        //         .find(item => item.view === view)

        //     return config
        // },
        currentCategoryIndex() {
            const categories = _.get(this.form, 'categories') || [];
            const currentID = this.$route.params.id;

            if (categories.length && currentID) {
                const index = _.findIndex(categories, item => item.id.toString() === currentID.toString());
                if (index >= 0) return index;
                else return null;
            } else {
                return null;
            }
        },
        // status: {
        //     get() {
        //         let enabled = true

        //         const start = this.publishStart
        //         if (start && enabled) enabled = compareAsc(new Date(), start) > 0

        //         const end = this.publishEnd
        //         // if (end && enabled) enabled = compareDesc(new Date(), addDays(end, 1)) > 0
        //         if (end && enabled) enabled = compareDesc(new Date(), end) > 0

        //         return enabled
        //     },
        //     set(active) {

        //         const start = this.publishStart
        //         const end = this.publishEnd

        //         if (active) {
        //             if (start && compareAsc(new Date(), start) < 0) this.publishStart = startOfDay(new Date())
        //             else if (end && compareDesc(new Date(), end) < 0) this.publishEnd = null
        //         } else {
        //             this.publishEnd = startOfDay(new Date())
        //         }

        //         if (this.currentCategoryIndex !== null) {
        //             const i = this.currentCategoryIndex
        //             store.commit('category/form/disabled', { i, value: ! active })
        //         }
        //     }
        // },
        publishStart: {
            get() {
                const start = _.get(this.currentCategory, 'publish_start');
                return start ? startOfDay(new Date(start * 1000)) : '';
            },
            set(value) {
                if (this.currentCategoryIndex !== null) {
                    const i = this.currentCategoryIndex;
                    const start = value !== null ? Math.round(value.getTime() / 1000) : null;
                    this.categoriesStore.setFormPublishStart({ i, value: start });

                    this.categoriesStore.setFormDisabled({ i, value: compareAsc(new Date(), value) <= 0 });
                }
            }
        },
        publishEnd: {
            get() {
                const end = _.get(this.currentCategory, 'publish_end');
                return end ? startOfDay(new Date(end * 1000)) : '';
            },
            set(value) {
                if (this.currentCategoryIndex !== null) {
                    const i = this.currentCategoryIndex;
                    const end = value !== null ? Math.round(value.getTime() / 1000) : null;
                    this.categoriesStore.setFormPublishEnd({ i, value: end });

                    this.categoriesStore.setFormDisabled({
                        i,
                        value: compareDesc(new Date(), value) <= 0
                    });
                }
            }
        },
        currentCollapseItem: {
            get() {
                // change collapseItem to "settings" if there are no section options availible
                if (this.hideMain || this.currentCategoryIsNew) return 'settings';
                return this.collapseItem;
            },
            set(value) {
                this.collapseItem = value;
            }
        },
        hideMain() {
            // const areas = _.get(this.config, 'grid.areas') || []
            // return this.view !== 'Reference' && ! this.sectionOptions.length && ! areas.filter(area => area.sections && area.sections.length).length
            return false;
        },
        products() {
            return _.get(this.currentCategory, 'products') || [];
        },
        productImports() {
            const settings = this.settingValues;
            const imports = _.get(this.activeCms, 'config.template.shop.import.products') || [];

            let allowed = [];
            imports.forEach(el => {
                let valid = true;
                try {
                    const conditions = el.conditions;
                    if (conditions && conditions.length) {
                        conditions.forEach(o => {
                            if (valid === false) return;

                            const { type, condition } = o;
                            switch (type) {
                                case 'eval':
                                    valid = eval(condition);
                                    break;

                                default:
                                    valid = false;
                            }
                        });
                    }
                } catch (error) {
                    console.error(error);
                    valid = false;
                }

                if (valid) allowed.push(el);
            });

            return allowed;
        },
        productExports() {
            const settings = this.settingValues;
            const exports = _.get(this.activeCms, 'config.template.shop.export.products') || [];

            let allowed = [];
            exports.forEach(el => {
                let valid = true;
                try {
                    const conditions = el.conditions;
                    if (conditions && conditions.length) {
                        conditions.forEach(o => {
                            if (valid === false) return;

                            const { type, condition } = o;
                            switch (type) {
                                case 'eval':
                                    valid = eval(condition);
                                    break;

                                default:
                                    valid = false;
                            }
                        });
                    }
                } catch (error) {
                    console.error(error);
                    valid = false;
                }

                if (valid) allowed.push(el);
            });

            return allowed;
        },
        setupStore() {
            return useSetupStore();
        },
        activeCms() {
            return this.setupStore.activeCms;
        },
        activeShop() {
            return _.get(this.activeCms, 'shop');
        },
        defaultCustomerGroupCurrency() {
            const code = _.get(this.activeShop, 'defaultCustomerGroup.currency.iso4217');
            return code || 'EUR';
        },
        enabledExtensions() {
            return this.setupStore.enabledExtensions;
        },
        settingValues() {
            return this.setupStore.settingValues;
        },
        categoriesStore() {
            return useShopCategoriesStore(pinia);
        },
        categoryProductStore() {
            return useShopCategoryProductStore(pinia);
        },
        form() {
            return this.categoriesStore.form;
        },
        options() {
            return this.categoriesStore.options;
        },
        categoryProductsLoading() {
            return this.categoryProductStore.loading;
        },
        categoryProductsPaginated() {
            return this.categoryProductStore.productsPaginated;
        },
        categoryProductsHasActiveFilters() {
            return !_.isEmpty(this.categoryProductsFilters);
        },
        categoryProductsIsEmpty() {
            return !this.categoryProductsHasActiveFilters && !this.categoryProductsPaginated.pageInfo.total;
        },
        categoryProductsShowFilters() {
            return this.categoryProductsHasActiveFilters || _.get(this.categoryProductStore.productsPaginated, 'showFilters') || false;
        },
        categoryProductsFilters() {
            const filters = _.cloneDeep(this.categoryProductsPaginated.filters);
            delete filters.shop;
            delete filters.categories;
            delete filters['exclusive-categories'];
            return filters;
        },
        categoryProductsSort() {
            const variables = this.categoryProductsPaginated.variables;
            const defaultSort = this.categoryProductsPaginated.defaultSort || { field: 'id', direction: 'desc' };
            const order = (variables.order !== undefined && variables.order !== '') ? variables.order : defaultSort.field;
            const direction = (variables.direction !== undefined && variables.direction !== '') ? variables.direction : defaultSort.direction;
            return { field: order, direction: direction };
        },
        currentCategoryIsLeaf() {
            const current = this.currentCategory;
            if (!current) return true;
            const allCategories = _.get(this.form, 'categories') || [];
            return !allCategories.some(
                element => element._lft > current._lft && element._rgt < current._rgt
            );
        },
        currentCategoryIsNew() {
            return _.startsWith(_.get(this.currentCategory, 'id'), 'new:');
        },
        categoryFilterKey() {
            return this.includeSubcategories ? 'categories' : 'exclusive-categories';
        },
    },
    watch: {
        currentCollapseItem(value) {
            if (value === 'products') this.initCategoryProducts();
        },
        includeSubcategories() {
            this.refreshCategoryFilter();
        },
    },
    methods: {
        initCategoryProducts() {
            if (!this.currentCategory || !this.currentCategory.id) return;

            const shopId = _.get(this.activeCms, 'shop.id');
            if (shopId) {
                const shopKey = 'shop';
                const shopValue = { key: shopKey, match: shopId, like: '', from: '', to: '', in: [] };
                this.categoryProductStore.defineFilterValue({ key: shopKey, value: shopValue });
            }

            this.refreshCategoryFilter();

            this.categoryProductStore.updateLoading(true);
            this.categoryProductStore.fetchProductsPaginated()
                .finally(() => this.categoryProductStore.updateLoading(false));
        },
        refreshCategoryFilter() {
            if (!this.currentCategory || !this.currentCategory.id) return;

            const otherKey = this.includeSubcategories ? 'exclusive-categories' : 'categories';
            this.categoryProductStore.defineFilterValue({
                key: otherKey,
                value: { key: otherKey, match: '', like: '', from: '', to: '', in: [] },
            });

            const key = this.categoryFilterKey;
            const value = { key, match: '', like: '', from: '', to: '', in: [Number(this.currentCategory.id)] };
            this.categoryProductStore.defineFilterValue({ key, value });

            if (this.currentCollapseItem === 'products') {
                this.categoryProductStore.updateLoading(true);
                this.categoryProductStore.fetchProductsPaginated()
                    .finally(() => this.categoryProductStore.updateLoading(false));
            }
        },
        categoryProductsChangePaginationSize(perPage) {
            this.categoryProductStore.defineItemsPerPage(perPage);
            this.categoryProductStore.updateLoading(true);
            this.categoryProductStore.fetchProductsPaginated()
                .finally(() => this.categoryProductStore.updateLoading(false));
        },
        categoryProductsChangeCurrentPage(currentPage) {
            this.categoryProductStore.defineCurrentPage(currentPage);
            this.categoryProductStore.updateLoading(true);
            this.categoryProductStore.fetchProductsPaginated()
                .finally(() => this.categoryProductStore.updateLoading(false));
        },
        categoryProductsChangeFilter(key, value, debounce = true) {
            this.categoryProductStore.defineCurrentPage(1);
            this.categoryProductStore.defineFilterValue({ key, value });
            if (debounce) this.debouncedCategoryProductsRefetch();
            else {
                this.categoryProductStore.updateLoading(true);
                this.categoryProductStore.fetchProductsPaginated()
                    .finally(() => this.categoryProductStore.updateLoading(false));
            }
        },
        debouncedCategoryProductsRefetch: _.debounce(function () {
            this.categoryProductStore.updateLoading(true);
            this.categoryProductStore.fetchProductsPaginated()
                .finally(() => this.categoryProductStore.updateLoading(false));
        }, 300),
        toggleCategoryProductsFilterVisibility() {
            const newValue = !this.categoryProductStore.productsPaginated.showFilters;
            this.categoryProductStore.defineFilterVisibility(newValue);
            this.setupStore.saveFilterVisibility({ scope: 'ex', key: 'shop_category_product', value: newValue });
        },
        categoryProductsHandleSortChange(key, value) {
            this.categoryProductStore.defineSorting({ key, value });
            this.categoryProductStore.updateLoading(true);
            this.categoryProductStore.fetchProductsPaginated()
                .finally(() => this.categoryProductStore.updateLoading(false));
        },
        categoryProductsHandleColsShow(visibleColumns) {
            this.categoryProductStore.defineActiveColumns(visibleColumns);
            apolloClient.clearStore();
        },
        disabledPublishStartDate(start) {
            const end = this.publishEnd;
            if (end) return compareAsc(addDays(start, 1), end) > 0;
            else return false;
        },
        disabledPublishEndDate(end) {
            const start = this.publishStart;
            if (start) return compareDesc(end, addDays(start, 1)) > 0;
            else return false;
        }
        // ...mapActions ({
        //     fetchCategory: 'category/fetchCategory',
        //     initializeCategory: 'category/initializeCategory',
        // }),
        // ...mapMutations({
        //     hideItem: 'category/form/markItemAsHidden',
        //     unhideItem: 'category/form/unmarkItemAsHidden',
        // }),
    },
    mounted() {
        if (this.currentCollapseItem === 'products') this.initCategoryProducts();
        // const id = this.$route.params.id
        // if (id) {
        //     if ( _.startsWith(id, 'new:')) {
        //         // check if the item already exists in state
        //         const categories = _.get(this.form, 'categories') || []
        //         const existing = categories.find(item => item.id === id)
        //         // initialize new category
        //         if (! existing || ! existing.page) this.initializeCategory(id)
        //         // setTimeout(() => this.collapseItem = ['content'], 100)
        //     } else if (this.currentCategory && ! this.currentCategory.page) {
        //         // load item if not already in store
        //         this.error = false
        //         this.notFound = false
        //         this.pathNotValid = false
        //         this.loading = true
        //         // const fetchDependencies = () => Promise.all([
        //         //     // ...
        //         // ])
        //         this.fetchCategory(id)
        //             .then(data => {
        //                 // setTimeout(() => this.collapseItem = ['content'], 300)
        //                 this.loading = false
        //                 // // store.commit('category/resetUI')
        //                 // const allowedCategorys = _.get(this.activeCms, 'config.template.pages', [])
        //                 // this.insertItemTypeOptions(allowedCategorys)
        //                 // this.loading = false
        //                 // // fetch options for dropdowns
        //                 // fetchDependencies()
        //                 //     .catch(err => {
        //                 //         this.error = true
        //                 //         /* eslint no-console: ["error", { allow: ["error"] }] */
        //                 //         console.error(err)
        //                 //         this.$notify.error({
        //                 //             title: this.$t('An error occurred!'),
        //                 //             message: this.$t('Category dependencies could not be fetched.'),
        //                 //             iconClass: 'fas el-icon-fa-times',
        //                 //             position: 'bottom-left',
        //                 //             customClass: 'dark',
        //                 //             duration: 8000,
        //                 //         })
        //                 //     })
        //             })
        //             .catch(err => {
        //                 this.loading = false
        //                 this.error = true
        //                 this.notFound = true
        //                 /* eslint no-console: ["error", { allow: ["error"] }] */
        //                 console.error(err)
        //                 this.$notify.error({
        //                     title: this.$t('An error occurred!'),
        //                     message: this.$t('Category could not be fetched.'),
        //                     iconClass: 'fas el-icon-fa-times',
        //                     position: 'bottom-left',
        //                     customClass: 'dark',
        //                     duration: 8000,
        //                 })
        //             })
        //     } else {
        //         // setTimeout(() => this.collapseItem = ['content'], 100)
        //     }
        // }
    }
};
</script>

<style lang="sass" scoped>
section.category-item-form
    display: flex
    height: 100%
    justify-content: center
    align-items: center
    .el-collapse
        flex-grow: 1
        align-self: flex-start
    .el-alert
        align-self: flex-start
    .loader
        min-height: 400px
        align-self: flex-start
section.category-item-form.empty
    .el-collapse-item.products ::v-deep
        .el-collapse-item__content
            padding-bottom: 0
            & > .visible-grid
                margin-bottom: 25px
            & > .page-main
                padding-bottom: 25px
.content-status-flex-col
    &.datepickers
        max-width: 600px
    &.status-switch
        flex-grow: 1

.category-products
    font-size: 0.9rem
    .table-top
        padding-left: 0
        padding-right: 0

.category-products-empty
    display: flex
    flex-direction: column
    align-items: center
    padding: 40px 20px
    text-align: center
    background-color: #f5f7fa
    border-radius: 4px
    &__icon
        display: flex
        align-items: center
        justify-content: center
        width: 56px
        height: 56px
        margin-bottom: 16px
        border-radius: 50%
        background-color: #fff
        i
            font-size: 1.5rem
            color: #c0c4cc
    &__title
        margin: 0
        font-size: 1rem
        font-weight: 500
        color: #303133
    &__hint
        margin: 6px 0 0
        color: #909399
    &__actions
        display: flex
        flex-wrap: wrap
        align-items: center
        justify-content: center
        gap: 24px
        margin-top: 20px

.under-construction
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center
    padding: 4rem
    text-align: center
    i
        font-size: 4rem
        color: rgba(0,0,0,0.2)
    h4
        margin-top: 1rem
        margin-bottom: 0
        font-size: 2rem
        font-weight: 300
        color: rgba(0,0,0,0.3)
</style>
